import { renderAnnotatedBlob } from "@/components/records/image-markup-editor/render-annotated-blob";

/**
 * Baseline annotated blob for a photo that has NOT (yet) been through the
 * markup editor.
 *
 * Every uploaded photo must carry the burned-in timestamp — the spec treats it
 * as *canonical* for the record ([[image-markup-editor.spec]] "Timestamp
 * burn-in"), because the native camera overlay on the `original` blob is a
 * fallback that crops can chop off and library picks may not have at all.
 * The editor only ever stamps the photo the user actually opened, so a
 * multi-photo batch needs its untouched photos stamped at capture / pick time
 * instead — otherwise photo 1 is stamped and photos 2..n are not.
 *
 * Runs the SAME `renderAnnotatedBlob` pipeline the editor's Done uses, with an
 * empty drawing list, so a stamped-but-unedited photo and an edited one are
 * byte-for-byte the same kind of output (and `annotatedBlob` stays "what I see
 * is what I submit" — the preview URL is minted from it).
 *
 * Re-opening the photo in the editor cannot double-stamp: the editor renders
 * from `renderFile` (the unstamped base), never from `annotatedBlob`.
 *
 * Falls back to `file` itself if the canvas pipeline is unavailable — losing
 * the stamp is bad, losing the photo is worse.
 */
export async function stampPhoto(file: File): Promise<Blob> {
  try {
    return await renderAnnotatedBlob({ file, drawings: [] });
  } catch (error) {
    console.error("Failed to stamp captured photo:", error);
    return file;
  }
}
